import { ZfDrawer, ZfDrawerContent, ZfDrawerHeader, ZfStack } from '@zafire/react';
import type { FunctionComponent, ReactNode } from 'react';
import { useRef } from 'react';
import { SETTINGS_DRAWER_CONTENT_WIDTH, SETTINGS_DRAWER_WIDTH } from '../../config/constants';
import { useShadowRootCustomStyles } from '../../hooks/useShadowRootCustomStyles';

interface IProps {
    isDrawerOpen: boolean;
    onCloseDrawer: () => void;
    title: string;
    children: ReactNode;
    height?: string;
}

export const SettingsDrawer: FunctionComponent<IProps> = ({ isDrawerOpen, onCloseDrawer, title, children, height = '100%' }) => {
    const drawerRef = useRef<HTMLZfDrawerElement>(null);

    // Keep the dialog frame non-scrolling (overflow: hidden). Scrolling is owned by ZfDrawerContent's
    // internal `.temporary` area, so the drawer has a single scrollbar instead of two nested ones
    useShadowRootCustomStyles(
        drawerRef,
        `dialog.drawer { margin-top: 0 !important; height: ${height} !important; margin-right: 0 !important; right: 0 !important; width: ${SETTINGS_DRAWER_WIDTH}px !important; min-width: ${SETTINGS_DRAWER_WIDTH}px !important; max-width: ${SETTINGS_DRAWER_WIDTH}px !important; overflow: hidden !important; box-sizing: border-box !important; }`,
    );

    return (
        <ZfDrawer
            anchor="parent"
            side="right"
            show={isDrawerOpen}
            overlay={false}
            onDrawerClose={onCloseDrawer}
            className="session-drawer"
            style={{
                height,
                flexShrink: 0,
                width: isDrawerOpen ? `${SETTINGS_DRAWER_WIDTH}px` : 0,
                minWidth: isDrawerOpen ? `${SETTINGS_DRAWER_WIDTH}px` : 0,
                maxWidth: isDrawerOpen ? `${SETTINGS_DRAWER_WIDTH}px` : 0,
                boxSizing: 'border-box',
            }}
            ref={drawerRef}
        >
            <ZfDrawerHeader showCloseButton={true}>{title}</ZfDrawerHeader>
            <ZfDrawerContent
                style={{
                    width: `${SETTINGS_DRAWER_WIDTH}px`,
                    minWidth: `${SETTINGS_DRAWER_WIDTH}px`,
                    maxWidth: `${SETTINGS_DRAWER_WIDTH}px`,
                    overflowX: 'hidden',
                    boxSizing: 'border-box',
                }}
            >
                <ZfStack
                    direction="column"
                    style={{
                        boxSizing: 'border-box',
                        width: `${SETTINGS_DRAWER_CONTENT_WIDTH}px`,
                        maxWidth: '100%',
                        maxHeight: '100%',
                    }}
                >
                    {children}
                </ZfStack>
            </ZfDrawerContent>
        </ZfDrawer>
    );
};
